import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash-es';
import { IncentivesWizardEntities } from 'client/data/models/incentives-wizard';
import { useCoreIncentivesWizard } from 'site-modules/core-page/hooks/use-core-incentives-wizard';
import { StartScreen } from 'site-modules/shared/components/incentives/incentives-wizard/steps/screens/start-screen';

export function IncentivesWizardInsight({
  incentives = null,
  setModelValue,
  styleId,
  makeName,
  modelName,
  makeSlug,
  modelSlug,
  year,
  engineType = null,
  zipCode = null,
  isUsed = false,
  isMobile = false,
  wizardState = undefined,
  onStartOver = noop,
  onFinish = noop,
  isInternational = false,
}) {
  const engineTypes = [engineType?.toLowerCase()];

  const { openWizard, wizardWidgetCommonConfig, incentivesAmount, creativeId, wizardDrawer } = useCoreIncentivesWizard({
    incentives,
    wizardState,
    styleId,
    year,
    makeSlug,
    modelSlug,
    makeName,
    modelName,
    engineTypes,
    isUsed,
    initialStepIndex: 1,
    setModelValue,
    fireOpenTracking: true,
    onFinish,
    onStartOver,
    isMobile,
  });

  return (
    <div className="incentives-wizard-insight" data-tracking-parent={creativeId}>
      {!incentivesAmount && <div>No rebates available in {zipCode}</div>}
      {!!incentivesAmount && (
        <Fragment>
          <div className="mb-0_75">
            {isInternational
              ? 'EV Rebates vary by state. We’ll help you find all the rebates you qualify for.'
              : `Maximize savings on your ${makeName} ${modelName}.`}
          </div>
          <StartScreen
            stepConfig={{
              hideImage: true,
              className: null,
              btnClassName: 'align-self-center py-0_5 px-1',
              isInternational,
              ...wizardWidgetCommonConfig,
            }}
            context={{ make: makeName }}
            allIncentives={wizardWidgetCommonConfig.eligibleIncentives}
            onAnswer={openWizard}
            creativeId={creativeId}
          />
        </Fragment>
      )}
      {wizardDrawer}
    </div>
  );
}

IncentivesWizardInsight.propTypes = {
  setModelValue: PropTypes.func.isRequired,
  styleId: PropTypes.number.isRequired,
  makeName: PropTypes.string.isRequired,
  modelName: PropTypes.string.isRequired,
  makeSlug: PropTypes.string.isRequired,
  modelSlug: PropTypes.string.isRequired,
  year: PropTypes.string.isRequired,
  incentives: IncentivesWizardEntities.IncentivesData,
  engineType: PropTypes.string,
  zipCode: PropTypes.string,
  isUsed: PropTypes.bool,
  isMobile: PropTypes.bool,
  onFinish: PropTypes.func,
  wizardState: IncentivesWizardEntities.IncentivesWizardUnwrappedPersistedState,
  onStartOver: PropTypes.func,
  isInternational: PropTypes.bool,
};
